import { Injectable } from '@angular/core';

import { AllowedFeatures } from '@project_app/config/feature.config';
import { DeviceService } from '@core/services/util/device.service';

@Injectable({
  providedIn: 'root'
})

export class FeatureToggleService {
    device: string;

    constructor(
        private deviceService: DeviceService
    ) {
        this.device = this.deviceService.getDevice();
    }

    isEnabled(feature): boolean {
        const { features } = AllowedFeatures;
        if (features[this.device].hasOwnProperty(feature)) {
            return features[this.device][feature];
        }
        return true;
    }
}
